import React from 'react';

/**
 * Inline Trove brand assets (vector, no network dependency).
 * Both render in `currentColor`, so set `color` on a wrapper (or via the
 * `color` prop) to tint them — e.g. white on the dark brand panel, ink on paper.
 * Source geometry: https://trove.com/wp-content/uploads/2022/06/Trove-Logo.svg
 */

const WORDMARK_PATH =
  'M12.479 25.461c0 .108-.075.18-.187.18H8.19c-.112 0-.187-.072-.187-.18V4.49c0-.108-.075-.18-.187-.18H.187C.075 4.31 0 4.238 0 4.13V.539c0-.108.075-.18.187-.18h20.11c.112 0 .186.072.186.18V4.13c0 .108-.074.18-.186.18h-7.63c-.113 0-.188.072-.188.18v20.971zm26.867-10.485c-.037.036-.037.072 0 .144l4.737 10.27c.074.145-.038.251-.188.251h-4.289c-.074 0-.15-.072-.187-.108l-4.326-9.409c-.037-.072-.075-.18-.187-.18h-5.854c-.113 0-.15.036-.15.144v9.373c0 .108-.075.18-.187.18h-4.102c-.112 0-.187-.072-.187-.18V.54c0-.108.075-.18.187-.18h10.928c4.214 0 7.868 3.411 7.868 7.793 0 3.016-1.677 5.531-4.064 6.824h.001zm-4.027-2.98c1.902-.072 3.654-1.76 3.654-3.842 0-2.083-1.827-3.842-3.804-3.842h-6.116c-.112 0-.15.072-.15.144v7.362c0 .108.075.18.187.18h6.229v-.002zM58.832 26c-7.868 0-11.822-5.387-11.822-13S50.964 0 58.832 0c7.869 0 11.823 5.387 11.823 13s-3.953 13-11.823 13zm7.16-13c0-5.638-2.536-9.05-7.16-9.05-4.624 0-7.16 3.411-7.16 9.05 0 5.639 2.536 9.05 7.16 9.05 4.624 0 7.16-3.411 7.16-9.05zm17.694 8.26c.075.18.298.18.373 0L91.034.467a.207.207 0 01.187-.108h4.29c.149 0 .224.144.186.25l-8.353 24.852c-.038.108-.15.18-.225.18H80.63c-.074 0-.187-.072-.224-.18L72.014.611a.192.192 0 01.187-.25h4.289c.075 0 .15.035.187.107l7.01 20.794v-.002zm36.137-10.318h-6.503c-.107 0-.179.069-.179.174v7.032c0 .008-.004.015-.004.023 0 1.256-1.068 3.63-3.807 3.632h-3.466c-2.384-.003-4.019-1.677-4.019-3.283 0-2.618 1.923-3.702 4.025-3.736h1.175c.106 0 .178-.07.178-.175v-3.493c0-.105-.07-.174-.178-.174h-1.175c-1.852 0-3.705-.978-3.705-3.318 0-1.642 1.461-3.423 3.705-3.423h7.094c.107 0 .179-.07.179-.175V.534c0-.106-.071-.175-.179-.175h-7.094c-4.773 0-7.98 3.283-7.98 7.264 0 2.689 1.675 4.295 2.957 5.064.178.105.142.278 0 .35-1.283.627-3.278 2.583-3.278 5.482 0 3.72 2.599 6.994 8.067 7.118h3.873c5.267-.079 7.845-3.492 7.901-7.342v-3.513h2.413c.106 0 .178-.07.178-.175v-3.492c0-.105-.07-.175-.178-.175v.002z';

/** The "T" glyph alone — used as a compact monogram mark. */
const MARK_PATH =
  'M12.479 25.461c0 .108-.075.18-.187.18H8.19c-.112 0-.187-.072-.187-.18V4.49c0-.108-.075-.18-.187-.18H.187C.075 4.31 0 4.238 0 4.13V.539c0-.108.075-.18.187-.18h20.11c.112 0 .186.072.186.18V4.13c0 .108-.074.18-.186.18h-7.63c-.113 0-.188.072-.188.18v20.971z';

interface LogoProps {
  height?: number;
  color?: string;
  style?: React.CSSProperties;
}

export const TroveWordmark = ({ height = 26, color = 'currentColor', style }: LogoProps) => (
  <svg
    viewBox="0 0 120 26"
    height={height}
    width={(120 / 26) * height}
    role="img"
    aria-label="Trove"
    style={{ display: 'block', ...style }}
  >
    <path d={WORDMARK_PATH} fill={color} />
  </svg>
);

export const TroveMark = ({ height = 24, color = 'currentColor', style }: LogoProps) => (
  <svg
    viewBox="0 0 20.5 26"
    height={height}
    width={(20.5 / 26) * height}
    role="img"
    aria-label="Trove mark"
    style={{ display: 'block', ...style }}
  >
    <path d={MARK_PATH} fill={color} />
  </svg>
);
